import { Checkbox, EditableTagField, Modal, Radio, RadioGroup, type Tag as TagType, Text } from '@viapeople/components'
import { useState } from 'react'

import { v7 as uuidv7 } from 'uuid'

const statusOptions = [
	//TODO: update this to use dynamic data
	{ value: 'Employee acknowledge', label: 'Employee acknowledge' },
	{ value: 'Feedback submitted', label: 'Feedback submitted' },
	{ value: 'Manager review', label: 'Manager review' },
]

interface AddFiltersProps {
	isOpen: boolean
	onClose: () => void
	onAddFilters: () => void
}

interface FiltersState {
	userType: string
	roles: TagType[]
	statuses: string[]
}

export const AddFilters = ({ isOpen, onClose, onAddFilters }: AddFiltersProps) => {
	const [filters, setFilters] = useState<FiltersState>({
		userType: 'Self Evaluators',
		roles: [],
		statuses: [],
	})

	const handleFilterChange = (key: string, value: string | TagType[] | string[]) => {
		setFilters((prev) => ({ ...prev, [key]: value }))
	}

	return (
		<Modal
			isOpen={isOpen}
			title='Filters'
			onClose={onClose}
			fullScreen
			buttons={[
				{
					children: 'Cancel',
					onClick: onClose,
				},
				{
					children: 'Apply',
					variant: 'primary',
					onClick: onAddFilters,
				},
			]}
			bodyClassName='h-full'>
			<div className='flex flex-col gap-4'>
				<Text variant='small' weight='semibold'>
					Select user type
				</Text>
				<RadioGroup
					name='userType'
					value={filters.userType}
					onChange={(value) => handleFilterChange('userType', value)}
					size='small'
					variant='primary'
					className='flex flex-row items-center gap-8'>
					<Radio value='Participants' label='Participants' />
					<Radio value='Reviewers' label='Reviewers' />
				</RadioGroup>
			</div>

			<hr className='border-neutral-100 my-6 -mx-6' />

			<div className='grid grid-cols-2 gap-12'>
				<div className='flex flex-col gap-3'>
					<Text variant='small' weight='semibold'>
						Select role
					</Text>
					<EditableTagField
						placeholder='Add role'
						value={filters.roles}
						onChange={(tags) => handleFilterChange('roles', tags)}
						onAddTag={(label) => {
							const trimmedLabel = label.trim()
							if (!trimmedLabel) return null

							return {
								id: uuidv7(),
								label: trimmedLabel,
							}
						}}
						maxTags={5}
					/>
				</div>

				<div className='flex flex-col gap-3'>
					<Text variant='small' weight='semibold'>
						Status
					</Text>
					<div className='flex flex-col gap-1'>
						{statusOptions.map((option) => (
							<span
								key={option.value}
								className={'flex items-center px-4 py-3 rounded-md cursor-pointer bg-neutral-100'}>
								<Checkbox
									checked={filters.statuses.includes(option.value)}
									onChange={(e) =>
										handleFilterChange(
											'statuses',
											e.target.checked
												? [...filters.statuses, option.value]
												: filters.statuses.filter((s) => s !== option.value),
										)
									}
									label={option.label}
									size='small'
									variant='primary'
								/>
							</span>
						))}
					</div>
				</div>
			</div>
		</Modal>
	)
}
